<template>
  <div style="z-index: 9999">
    <div class="library-viewer-section base-type-layout w-100 h-100">
      <!-- SECTION TOP -->
      <section class="top black index-999">
        <div class="container">
          <!-- TOP -->
          <div class="row">
            <div
              class="col-12 d-flex justify-content-between align-items-center nowrap"
            >
              <!-- LEFT -->
              <div
                class="left d-flex justify-content-start align-items-center nowrap"
              >
                <!-- AVATAR -->
                <div class="avatar avatar-square brand_inverse_light_bg">
                  <img
                    v-lazy="file_data.image"
                    alt
                    class="avatar-img"
                    v-if="file_data.image"
                  />
                  <!-- AVATAR TEXT -->
                  <div
                    class="avatar-text white-text font-weight-bold"
                    :class="setAvatarBg"
                    v-else
                  >
                    {{ userInitial }}
                  </div>
                </div>

                <!-- USER INFO -->
                <div class="user-info">
                  <div class="name font-weight-bold">
                    {{ file_data.fullname }}
                  </div>
                  <div class="date color_grey_dark">
                    <span>{{ file_data.date }}</span> &nbsp;
                    <span>{{ file_data.time }}</span>
                  </div>
                </div>
              </div>

              <!-- RIGHT -->
              <div
                class="right d-flex justify-content-start align-items-center nowrap"
              >
                <!-- DOWNLOAD ICON -->
                <div
                  class="avatar pointer mr-2 hint--rounded hint--bottom hint--primary"
                  aria-label="Download"
                  style="overflow: unset"
                  @click="downloadFile"
                >
                  <span
                    class="icon-cloud-download flex-center white-text font-30"
                  ></span>
                </div>

                <!-- SHARE ICON -->
                <div
                  v-if="false"
                  class="avatar pointer mx-2 hint--rounded hint--bottom hint--primary"
                  aria-label="Share"
                  style="overflow: unset"
                >
                  <span
                    class="icon-share flex-center white-text font-19"
                  ></span>
                </div>

                <!-- DIVIDER -->
                <div class="divider mx-2">
                  <span class="invisible">x</span>
                </div>

                <!-- CLOSE ICON -->
                <div
                  class="avatar pointer ml-2 hint--rounded hint--bottom hint--primary"
                  aria-label="Close"
                  style="overflow: unset"
                  @click="$emit('closeTriggered')"
                >
                  <span
                    class="icon-decline flex-center white-text font-21 font-weight-400"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- SECTION TOP -->

      <!-- SECTION BOTTOM -->
      <section class="bottom w-100">
        <!-- BOTTOM -->
        <div class="container">
          <div class="row">
            <div
              class="data-column col-12 d-flex flex-column justify-content-center align-items-center nowrap"
            >
              <!-- IMAGE CONTAINER -->
              <div
                class="image-container position-relative"
                v-if="file_type === 'image'"
              >
                <img
                  v-lazy="file_data.url[selected_index].filename"
                  :alt="file_data.url[selected_index].title"
                />

                <div
                  class="navigation-buttons position-relative w-100 h-100"
                  v-if="file_data.url.length > 1"
                >
                  <!-- LEFT NAV -->
                  <div
                    v-if="selected_index > 0"
                    class="left-nav nav avatar pointer"
                    @click="selected_index--"
                    title="Previous"
                  >
                    <span class="icon-caret-left color_ash"></span>
                  </div>

                  <!-- RIGHT NAV -->
                  <div
                    v-if="selected_index < file_data.url.length - 1"
                    class="right-nav nav avatar pointer"
                    @click="selected_index++"
                    title="Next"
                  >
                    <span class="icon-caret-right color_ash"></span>
                  </div>
                </div>
              </div>
              <!-- IMAGE CONTAINER -->

              <!-- VIDEO CONTAINER -->
              <div class="video-wrapper" v-if="file_type === 'video'">
                <div class="video-content">
                  <!-- POPCORN VIDEO  -->
                  <template v-if="is_popcorn">
                    <vue-iframe
                      :src="file_data.url"
                      allow="camera *; geolocation *; microphone *; autoplay *"
                      frame-id="my-ifram"
                      @load="onLoad"
                      name="my-frame"
                      width="150px"
                      height="200px"
                    />
                  </template>

                  <template v-else>
                    <video
                      @click="pausePlayingVideo"
                      :poster="
                        file_data.thumbnail
                          ? file_data.thumbnail
                          : dynamicImg('PostVideoLg.png')
                      "
                      class="video-player"
                      controlslist="nodownload"
                      ref="videoPlayerLg"
                    >
                      <source :src="file_data.url" type="video/mp4" />
                      Your Browser does not support the video tag
                    </video>

                    <!-- PLAY BUTTON -->
                    <div
                      class="avatar play-icon"
                      @click="playPausedVideo"
                      v-if="show_play_btn"
                    >
                      <span
                        class="icon-play-bg brand_accent index-9 flex-center pointer"
                      ></span>
                    </div>
                    <!-- PLAY BUTTON -->

                    <!-- VIDEO OVERLAY -->
                    <div
                      class="overlay position-absolute index--9 w-100 h-100"
                    ></div>
                    <!-- VIDEO OVERLAY -->
                  </template>
                </div>

                <!-- VIDEO TITLE -->
                <div class="video-title brand_inverse_light mt-4 text-center">
                  {{ file_data.title }}
                </div>
              </div>
              <!-- VIDEO CONTAINER -->

              <!-- FILE COMTAINER -->
              <div
                class="file-wrapper w-100 h-100"
                v-if="file_type == 'document'"
              >
                <div class="row h-100 w-100">
                  <div class="col-12 file-container w-100 h-100">
                    <template v-if="file_data.extension === 'pdf'">
                      <div class="d-none">
                        <pdf
                          :src="getFileURL"
                          @num-pages="pageCount = $event"
                        ></pdf>
                      </div>

                      <div
                        class="loading-section d-flex flex-center"
                        v-if="show_loader"
                      >
                        <div class="avatar avatar_md mr-2">
                          <span
                            class="icon-dotted-roller flex-center font-30 animate border_grey_light"
                          ></span>
                        </div>
                        <div class="font-12-5 border_grey_light">
                          Loading...
                        </div>
                      </div>

                      <div
                        class="mb-1 mb-md-2"
                        v-for="(_, index) in pageCount"
                        :key="index"
                      >
                        <pdf
                          :src="getFileURL"
                          :page="index + 1"
                          @loaded="show_loader = false"
                        ></pdf>
                      </div>
                    </template>

                    <template v-else>
                      <VueDocPreview
                        :url="file_data.url"
                        type="office"
                      ></VueDocPreview>
                    </template>

                    <div
                      v-if="false"
                      class="navigation-row font-14 d-flex justify-content-between align-items-center"
                    >
                      <div class="page-counter border_grey_light">
                        {{ currentPage }} / {{ pageCount }}
                      </div>
                      <div
                        class="page-nav d-flex justify-content-end align-items-center nowrap"
                      >
                        <!-- PREVIOUS NAV -->

                        <div
                          class="prev-page avatar brand_white_bg pointer mr-2"
                          title="Previous page"
                          :class="currentPage === 1 ? 'disable-nav' : null"
                          @click="currentPage--"
                        >
                          <span
                            class="icon-caret-left font-weight-bold color_ash font-15 flex-center"
                          ></span>
                        </div>

                        <!-- NEXT NAV -->
                        <div
                          class="next-page avatar brand_white_bg pointer ml-2"
                          title="Next page"
                          :class="
                            currentPage === pageCount ? 'disable-nav' : null
                          "
                          @click="currentPage++"
                        >
                          <span
                            class="icon-caret-right font-weight-bold color_ash font-15 flex-center"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- FILE COMTAINER -->
            </div>
          </div>
        </div>
      </section>
    </div>

    <ResponseDialog
      v-if="response_dialog"
      :alert_msg="alert_card_msg"
      :alert_type="alert_card_type"
      @closeAlert="toggleResponseDialog"
    ></ResponseDialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import pdf from "vue-pdf";
import VueDocPreview from "vue-doc-preview";
import { formatDate, formatTime, setInitial } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";

export default {
  name: "LibraryViewer",

  components: {
    pdf,
    VueDocPreview,
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  props: {
    file_type: String,
    file_data: Object,
    video_play_time: {
      type: Number,
      default: 0,
    },
    selected_image: Number,
  },

  computed: {
    userInitial() {
      if (Object.keys(this.file_data).length)
        return setInitial(this.file_data.fullname);
      else return "N/A";
    },

    setAvatarBg() {
      if (Object.keys(this.file_data).length)
        return setProfileBg(this.file_data.fullname);
      else return "brand_red_bg";
    },

    getFileURL() {
      return this.file_data.url;
    },

    formatLibraryDate() {
      // console.log(this.file_data.date);
      let date = new Date(this.file_data.date.replace(/\s/, "T") + "Z");
      // console.log(date);
      let new_date = formatDate(date);
      // console.log(new_date);
      return new_date;
    },
  },

  filters: {
    getDateValue(value) {
      let date = new Date(value.replace(/\s/, "T") + "Z");

      let year = date.getFullYear(),
        month = date.toLocaleString("default", {
          month: "short",
        }),
        day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;

      return `${day} ${month}, ${year}`;
    },

    getTimeValue(value) {
      let time = new Date(value.replace(/\s/, "T") + "Z");

      let AmOrPm = time.getHours() >= 12 ? "PM" : "AM",
        hours = time.getHours() % 12 || 12,
        minutes = time.getMinutes();
      return `${hours}:${minutes} ${AmOrPm}`;
    },
  },

  data() {
    return {
      selected_index: this.selected_image,
      show_play_btn: true,
      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,

      pageCount: 1,
      currentPage: 1,
      show_nav: false,

      is_popcorn: false,
      myIframe: null,

      show_loader: true,
    };
  },

  mounted() {
    if (this.file_type === "video") {
      let videoObj = this.$refs.videoPlayerLg;
      videoObj.currentTime = this.video_play_time;

      // CHECK VIDEO TYPE
      this.isPopCornVideoType();
    }
  },

  methods: {
    ...mapActions(["downloadDocument"]),

    onLoad(frame) {
      this.myIframe = frame.contentWindow;
    },

    formatFileTime(date) {
      let new_date = new Date(date.replace(/\s/, "T") + "Z");
      return formatTime(new_date);
    },

    formatFileDate(date) {
      console.log(date);
      let new_date = new Date(date.replace(/\s/, "T") + "Z");
      return formatDate(new_date);
    },

    showNavigation() {
      this.show_nav = !this.show_nav;
    },

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    playPausedVideo() {
      let videoObj = document.querySelector(".video-player");
      videoObj.currentTime = this.video_play_time;
      // console.log(this.video_play_time);

      if (videoObj.paused) {
        videoObj.play();
        videoObj.controls = true;
        this.show_play_btn = false;
      }
    },

    pausePlayingVideo() {
      let videoObj = document.querySelector(".video-player");
      if (!videoObj.paused) {
        videoObj.pause();
        videoObj.removeAttribute("controls");
        this.show_play_btn = true;
      }
    },

    downloadFile() {
      this.downloadDocument(this.file_data.token)
        .then((response) => {
          let data = response.data;
          if (data.filename) {
            this.alert_card_msg = "Downloading video...";
            this.alert_card_type = "warning";
            this.toggleResponseDialog();

            // FETCH FILE DETAIL
            fetch(data.filename).then((t) => {
              return t.blob().then((b) => {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(b);
                a.setAttribute("download", data.title + "." + data.extension);
                a.click();
              });
            });
          }
        })
        .catch((err) => console.log(err));
    },

    setupPopcorn() {
      this.$nextTick(() => {
        let popCorn = document.createElement("script");
        popCorn.setAttribute(
          "src",
          "http://popcornjs.org/code/dist/popcorn-complete.min.js"
        );
        popCorn.setAttribute("async", true);
        popCorn.setAttribute("defer", true);
        document.head.appendChild(popCorn);
      });
    },

    isPopCornVideoType() {
      if (!this.file_data.url.endsWith(".mp4")) {
        this.is_popcorn = true;
        this.setupPopcorn();
      } else this.is_popcorn = false;
    },
  },
};
</script>

<style lang="scss">
.library-viewer-section {
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto !important;
  z-index: 2000;
  background-color: #0f0f0f;
  transition: all 0.5s ease-in-out;
  animation: panel-slide-down 0.6s ease-in-out forwards;

  .top {
    padding-top: 12px;
    padding-bottom: 12px;

    .left {
      .avatar {
        @include equal_min_edge(42);
        margin-right: 15px;

        @include breakpoint_max(sm) {
          @include equal_min_edge(34);
          margin-right: 10px;
        }
      }

      .name {
        font-size: 14px;
        line-height: 17px;
        color: #dbf5f8;
        margin-bottom: 3px;

        @include breakpoint_max(sm) {
          font-size: 12px;
          line-height: 15px;
        }
      }

      .date {
        font-size: 12px;
        line-height: 16px;

        @include breakpoint_max(sm) {
          font-size: 10px;
          line-height: 14px;
        }
      }
    }

    .right {
      .divider {
        background: #fff;
        height: 110%;
        min-width: 1px;
        width: 1px;
      }

      .avatar {
        .icon-cloud-download {
          font-size: 19px !important;
        }
        .icon-decline {
          font-size: 19px !important;
        }
      }
    }
  }

  .bottom {
    height: 90vh;

    .data-column {
      height: 89.5vh;
      margin: auto;
      width: 100%;
    }

    .image-container {
      margin: auto;
      position: relative;
      width: 80%;
      height: 80vh;

      @include breakpoint_max(md) {
        width: 100%;
        height: 80vh;
      }

      img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: all 0.35s linear;

        @include breakpoint_max(md) {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }

      .navigation-buttons {
        .nav {
          position: absolute;
          background: $color_white;
          top: 50%;
          transform: translateY(-50%);
          @include equal_min_edge(42);
          transition: all 0.4s ease-in-out;

          @include breakpoint_max(md) {
            @include equal_min_edge(36);
          }

          @include breakpoint_max(sm) {
            @include equal_min_edge(34);
          }

          span {
            @include transform_center;
            font-size: 18px;
            font-weight: bold;
          }

          &:hover {
            opacity: 0.75;
          }
        }

        .left-nav {
          left: -10%;
          @include breakpoint_max(md) {
            left: 17px;
            font-size: 14px;
          }
        }

        .right-nav {
          right: -10%;
          @include breakpoint_max(md) {
            right: 17px;
            font-size: 14px;
          }
        }

        .opacify {
          opacity: 0.75;
        }
      }
    }

    .video-wrapper {
      width: 100%;
      height: 87vh;
      margin: auto;
      @include flex_column_center;
    }

    .video-content {
      position: relative;
      width: 70%;
      height: 550px;

      @include breakpoint_max(lg) {
        width: 100%;
        height: 510px;
      }

      @include breakpoint_max(md) {
        width: 100%;
        height: 380px;
      }

      @include breakpoint_max(sm) {
        width: 100%;
        height: 350px;
      }

      @include breakpoint_max(xs) {
        width: 100%;
        height: 330px;
      }

      .avatar {
        @include equal_min_edge(60);
        @include transform_center;
        z-index: 9;

        span {
          font-size: 55px;
        }
      }

      .overlay {
        // background: #000000;
        opacity: 0.5;
      }

      video {
        @include img_contain;
      }
    }

    .file-wrapper {
      padding: auto;
      width: 100%;
      margin: auto;
      @include flex_column_center;
      justify-content: flex-start;
      overflow: auto;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }

      .file-container {
        // margin-top: 10px;
        // margin-bottom: 10px;
        // padding-top: 40px;
        width: 100%;

        .navigation-row {
          margin-top: 15px;
          margin-bottom: 30px;
          .page-nav {
            .prev-page,
            .next-page {
              transition: all 0.4s ease-in-out;
              &:hover {
                background: $brand_accent !important;
              }
            }

            .disable-nav {
              pointer-events: none !important;
              cursor: not-allowed !important;
              background: rgba($brand_white, 0.5) !important;
            }
          }
        }
      }
    }
  }
}
</style>
